import React from "react"
import { Container } from "react-bootstrap"

export function NotFoundPage() {
  return (
    <Container className="d-flex h-100">
      <h1 className="h3 m-auto">404 – Not Found</h1>
    </Container>
  )
}
